
module.exports = {
	notes: `Used by images and video. 
	<p>For demo: <br>
	http://localhost:7000/components/preview/artikelsida--advanced <br>
	http://localhost:7000/components/preview/artikelsida</p>`,
	status: 'ready',
};
